import { useCallback } from 'react';

import Text from '@ui/text/text/text';
import { EPaletteModes, ThemePack } from '@/types/theme-packs.types';
import Button from '@ui/buttons/button/button';
import ThemeInfoPillColors from './theme-info-pill-colors';
import Container from '@ui/container/container';
import { useGetColorOptionsFromColor } from '@/utils/colors/use-get-color-options-from-color';
import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';
import { TooltipPortalPosition } from '@ui/tooltip-portal/tooltip-portal-types';

type ThemePillInfoProps = {
  themePack: ThemePack;
  themeMode: EPaletteModes;
  allowThemeTrayToggle?: boolean;
  onClick?: () => void;
  open?: boolean;
};

const ThemeInfoPill = ({ open, onClick, themePack, themeMode, allowThemeTrayToggle = true }: ThemePillInfoProps) => {
  const themeColors = useGetColorOptionsFromColor(themePack, themeMode);

  const handleClick = useCallback(() => {
    if (!allowThemeTrayToggle) return;

    onClick?.();
  }, [allowThemeTrayToggle, onClick]);

  if (!themePack) return null;
  return (
    <TooltipPortal
      position={TooltipPortalPosition.BOTTOM}
      tooltipContent={
        <Text design="GlobalIcoText1" className="P2">
          {themePack?.title}
        </Text>
      }
      showOnFocus
      verticalOffset={3}
      styles={{ padding: '8px', backgroundColor: 'var(--global-cont-2)' }}
    >
      <Button
        data-component="ThemeInfoPill"
        backgroundColor={allowThemeTrayToggle && open ? 'var(--global-cont-2)' : 'var(--global-cont-1)'}
        hoverBackgroundColor={allowThemeTrayToggle && open ? 'var(--global-cont-2)' : 'var(--global-cont-1)'}
        focusBackgroundColor="var(--global-cont-2)"
        disabledOpacity={1}
        height="32px"
        style={{
          transition: 'scale 0.2s ease-in-out, box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out',
          boxShadow:
            allowThemeTrayToggle && open
              ? '6px 2px 20px 0 var(--global-cont-1), -6px 2px 20px 0 var(--global-cont-1)'
              : undefined,
        }}
        className={`clear-button radius-8`}
        disabled={!allowThemeTrayToggle || !themeColors}
        onClick={handleClick}
        name="theme-info-toggle" /* used in theme-tray.tsx */
      >
        <Container
          background={allowThemeTrayToggle && open ? 'var(--global-cont-2)' : 'inherit'}
          hoverBackground={allowThemeTrayToggle && open ? 'var(--global-cont-2)' : 'var(--global-cont-2)'}
          className="flex fd-row jc-flex-start ai-center radius-7"
          height="100%"
          width="100%"
          margin="0 1px"
          style={{ padding: 5.5 }}
        >
          <ThemeInfoPillColors themeColors={themeColors} />
        </Container>
      </Button>
    </TooltipPortal>
  );
};

export default ThemeInfoPill;
